/* eslint-disable */

import { onGet } from './http.api';

export interface CampaignRuleDto {
  Id: string;
  CampaignId: number;
  Category: string;
  RuleCode: string;
  RuleType: string;
  Title: string;
  Content: string;
  SortOrder: number;
  IsRequired: boolean;
}

interface ApiResponse<T> {
  Success: boolean;
  Data: T;
  Message?: string;
}

export const GetCampaignRules = async (campaignId: string, lang: string = 'vi'): Promise<CampaignRuleDto[]> => {
  const res = await onGet<ApiResponse<CampaignRuleDto[]>>(
    `/CampaignRule/GetCampaignRules?campaignId=${campaignId}&lang=${lang}`,
  );

  return res?.Data || [];
};
